'use strict';
import * as $j_java$002eio$002e$002dPrint$002dStream from "./java.io.-Print-Stream.js";
import * as $j_java$002elang$002e$002dJ$002dS$002dConsole$002dBased$002dPrint$002dStream$0024$002dDummy$002dOutput$002dStream from "./java.lang.-J-S-Console-Based-Print-Stream$-Dummy-Output-Stream.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V($thiz, line) {
  if (((typeof console) !== "undefined")) {
    if (($thiz.IH && (!(!(!(!console.error)))))) {
      console.error(line);
    } else {
      console.log(line);
    }
  }
}
export { $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V as $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V };
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream(isErr) {
  this.IH = false;
  this.rV = null;
  this.IH = isErr;
  $j_java$002eio$002e$002dPrint$002dStream.$ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__(this, new $j_java$002elang$002e$002dJ$002dS$002dConsole$002dBased$002dPrint$002dStream$0024$002dDummy$002dOutput$002dStream.$c_jl_JSConsoleBasedPrintStream$DummyOutputStream(), false, null);
  this.rV = "";
}
export { $c_jl_JSConsoleBasedPrintStream as $c_jl_JSConsoleBasedPrintStream };
$p = $c_jl_JSConsoleBasedPrintStream.prototype = new $j_java$002eio$002e$002dPrint$002dStream.$h_Ljava_io_PrintStream();
$p.constructor = $c_jl_JSConsoleBasedPrintStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream() {
}
export { $h_jl_JSConsoleBasedPrintStream as $h_jl_JSConsoleBasedPrintStream };
$h_jl_JSConsoleBasedPrintStream.prototype = $p;
$p.WG = (function(s) {
  this.xu(((s === null) ? "null" : s));
});
$p.xu = (function(s) {
  var rest = s;
  while ((rest !== "")) {
    var this$1 = rest;
    var nlPos = (this$1.indexOf("\n") | 0);
    if ((nlPos < 0)) {
      this.rV = (("" + this.rV) + rest);
      rest = "";
    } else {
      var $x_1 = this.rV;
      var this$2 = rest;
      $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V(this, (("" + $x_1) + this$2.substring(0, nlPos)));
      this.rV = "";
      var this$4 = rest;
      var beginIndex = ((1 + nlPos) | 0);
      rest = this$4.substring(beginIndex);
    }
  }
});
var $d_jl_JSConsoleBasedPrintStream = new $j_java$002elang$002e$002dObject.$TypeData().i($c_jl_JSConsoleBasedPrintStream, "java.lang.JSConsoleBasedPrintStream", ({
  kd: 1,
  jZ: 1,
  jX: 1,
  db: 1,
  d9: 1,
  dd: 1,
  da: 1,
  dc: 1
}));
export { $d_jl_JSConsoleBasedPrintStream as $d_jl_JSConsoleBasedPrintStream };
